if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Share dentist
         *
         * Specific functionality to comply with business rules in 'MijnZZ' environment on adding 'share dentist' option to your insurance
         *
         * @param input - select box containing sharing options
         */
        ZZ.ShareDentist = function(input) {
            var base = this;
            base.input = input;
            base.messageContainer = $("#" + base.input.attr("data-message-id"));
            base.url = base.input.attr("data-url");
            base.form = base.input.parents("form:first");
            base.insuranceOption = base.form.find("#additionalinsurance");
            base.template = new ZZ.Template(base.messageContainer);
            base.noSharing =
                base.input.attr("data-sharing-not-possible-with") || "";
            base.sharingNotPossibleNote = base.input.next(
                ".notification-sharing-not-possible"
            );
            base.shareMaxNote = $(".notification-sharing-maximum");
            base.assignListeners();
            base.input.trigger("change");
            base.insuranceOption.trigger("change");
        };

        ZZ.ShareDentist.prototype = {
            assignListeners: function() {
                var base = this;
                base.input.on("change", function() {
                    var selectedValue = base.input.find(":selected").val();
                    if (selectedValue !== "") {
                        base.getShareInfo();
                    } else {
                        base.hideMessage();
                    }
                });

                base.insuranceOption.on("change", function() {
                    var selectedValue = $(this).val();
                    if (base.noSharing.indexOf(selectedValue) > -1) {
                        base.input.attr("disabled", "disabled");
                        base.input[0].selectedIndex = 0;
                        base.input.trigger("change");
                        base.sharingNotPossibleNote.find("strong").text(
                            $(this)
                                .find(":selected")
                                .text()
                        );
                        base.sharingNotPossibleNote.fadeIn(200);
                        base.shareMaxNote.hide();
                    } else if (
                        typeof base.input.attr("disabled") !== "undefined"
                    ) {
                        base.sharingNotPossibleNote.fadeOut(200);
                        base.input.removeAttr("disabled");
                    } else {
                        base.getShareInfo();
                    }
                });
            },

            getShareInfo: function() {
                var base = this,
                    parameters = base.form.serialize(),
                    method = base.form.attr("method") || "GET";

                $.ajax({
                    url: base.url,
                    dataType: "json",
                    data: parameters,
                    type: method,
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(data) {
                        var shareDentist = data.sharedentist;
                        if (shareDentist.toString().toUpperCase() !== "OK") {
                            shareDentist.new_insurance = base.insuranceOption
                                .find(":selected")
                                .text();
                            base.highlightMessage(shareDentist);
                        } else {
                            base.hideMessage();
                        }

                        if (
                            typeof data.maxshareamount !== "undefined" &&
                            $.trim(data.maxshareamount) !== ""
                        ) {
                            base.shareMaxNote
                                .html(data.maxshareamount)
                                .fadeIn(200);
                        }
                    },
                    error: function() {
                        base.hideMessage();
                    }
                });
            },

            highlightMessage: function(json) {
                var base = this;
                base.template.appendData(json);
                base.messageContainer.fadeIn(200).removeClass("is-hidden");
            },

            hideMessage: function() {
                var base = this;
                base.messageContainer.fadeOut(200);
            }
        };

        /** Share dentist prospect
         *
         * Specific functionality to choose share dentist option in prospect environment of ZZ site
         * Simple version: only sharing with partner is possible
         *
         */
        ZZ.ShareDentistProspect = function(checkbox) {
            var base = this;
            base.checkbox = checkbox;
            base.checkboxPartner = $("#share-dentist-partner");
            base.compareCheckboxes = base.checkbox
                .closest("fieldset")
                .prev(".compare-table-container")
                .find(":checkbox");
            base.compareTable = base.checkbox
                .closest("fieldset")
                .prev(".compare-table-container");
            base.av = $(
                $("[data-ref-bv-prospect-main]")
                    .first()
                    .attr("data-update-gemak-av-select")
            );
            base.avPartner = $(
                $("[data-ref-bv-prospect-partner]")
                    .first()
                    .attr("data-update-gemak-av-select")
            );
            //
            base.bvMain = $("[data-ref-bv-prospect-main]");
            base.bvPartner = $("[data-ref-bv-prospect-partner]");
            //
            if (base.checkboxPartner.length === 0) {
                // no partner on page
                return;
            }

            base.checkboxPartner.prop("disabled", true);
            $(".dental-sharing-not-possible-text-partner-keuze").hide(0);
            base.assignListeners();
            base.updateSharing();
        };

        ZZ.ShareDentistProspect.prototype = {
            assignListeners: function() {
                var base = this;

                base.compareTable.on(
                    "rebuild.compareTable",
                    base.reAssignListeners.bind(this)
                );

                base.checkbox.on("change.ShareDentistProspect", function() {
                    // if av partner is chosen, but av main insured not yet
                    if (
                        base.av.find(":selected").prop("disabled") &&
                        !base.avPartner.find(":selected").prop("disabled")
                    ) {
                        base.avPartner.trigger("change.ShareDentistProspect");
                    } else {
                        base.updateSharing();
                    }
                });

                base.bvMain.on("change", function() {
                    if (
                        $(this)
                            .find(":selected, :checked")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.checkbox.prop("checked", false);
                        base.checkbox.prop("disabled", true);
                        base.disableSharing();
                    } else {
                        if (
                            !base.av
                                .find(":selected")
                                .is(
                                    "[data-no-dental-sharing], .no-dental-sharing"
                                )
                        ) {
                            base.checkbox.prop("disabled", false);
                            base.enableSharing();
                        }
                    }
                });

                base.bvPartner.on("change", function() {
                    if (
                        $(this)
                            .find(":selected, :checked")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.checkbox.prop("checked", false);
                        base.checkbox.prop("disabled", true);
                        $(
                            ".dental-sharing-not-possible-text-partner-keuze"
                        ).show();
                        base.compareCheckboxes.prop("disabled", true);
                        base.disableSharing();
                    } else {
                        if (
                            base.av
                                .find(":selected")
                                .is(
                                    "[data-no-dental-sharing], .no-dental-sharing"
                                )
                        ) {
                            base.checkbox.prop("disabled", true);
                            base.compareCheckboxes.prop("disabled", true);
                        } else {
                            base.checkbox.prop("disabled", false);
                            base.compareCheckboxes.prop("disabled", false);
                        }

                        $(
                            ".dental-sharing-not-possible-text-partner-keuze"
                        ).hide();

                        if (base.checkbox.is(":checked")) {
                            base.enableSharing();
                        } else {
                            base.disableSharing();
                        }
                    }
                });

                base.av.on("change.ShareDentistProspect", function() {
                    base.updateSharing();
                });

                base.avPartner.on("change.ShareDentistProspect", function() {
                    if (base.checkbox.is(":checked")) {
                        base.av.val(base.avPartner.val());
                        base.av.trigger("change");
                    }
                });
            },

            /**/
            reAssignListeners: function() {
                var base = this;
                base.compareCheckboxes = base.checkbox
                    .closest("fieldset")
                    .prev(".compare-table-container")
                    .find(":checkbox");
                base.compareCheckboxes.prop(
                    "checked",
                    base.checkbox.prop("checked")
                );
                base.compareCheckboxes.prop(
                    "disabled",
                    base.checkbox.prop("disabled")
                );
                base.compareCheckboxes.on("change", function() {
                    base.checkbox.prop(
                        "checked",
                        !base.checkbox.prop("checked")
                    );
                    base.updateSharing();
                });
            },

            /**/
            updateSharing: function() {
                var base = this;

                // Show/hide span.delen / span.niet-delen
                if (base.checkbox.is(":checked")) {
                    $(".compare-table").addClass("delen");
                } else {
                    $(".compare-table").removeClass("delen");
                }

                // Show partner's aanvullende verzekering link if it's hidden
                var $linkAanvullendeVerzekering = base.avPartner
                    .parents("fieldset")
                    .find('a[data-interaction="Toggle"]');

                if (
                    base.av
                        .find(":selected")
                        .is("[data-no-dental-sharing], .no-dental-sharing")
                ) {
                    var sharingNotPossibleText = $(
                        ".dental-sharing-not-possible-text"
                    );
                    sharingNotPossibleText.show();

                    base.checkbox.prop("disabled", true);
                    base.checkbox.prop("checked", false);
                    base.compareCheckboxes.prop("disabled", true);

                    if (
                        base.av.find(":selected").attr("data-value-none") !==
                        undefined
                    ) {
                        $(".dental-sharing-not-possible-text").hide();
                    }
                    sharingNotPossibleText
                        .find(".insurance")
                        .text(base.av.find(":selected").text());
                    base.disableSharing();
                } else {
                    base.checkbox.prop("disabled", false);
                    base.compareCheckboxes.prop("disabled", false);

                    $(".dental-sharing-not-possible-text").hide();

                    if (base.checkbox.is(":checked")) {
                        base.enableSharing();
                    } else {
                        base.disableSharing();
                    }
                }

                if (
                    base.bvPartner
                        .find(":selected, :checked")
                        .is("[data-no-dental-sharing], .no-dental-sharing")
                ) {
                    base.checkbox.prop("checked", false);
                    base.checkbox.prop("disabled", true);
                    base.compareCheckboxes.prop("disabled", true);
                    $(".dental-sharing-not-possible-text-partner-keuze").show();
                }
            },

            enableSharing: function() {
                var base = this,
                    formRowPartner = base.checkboxPartner.closest(".form-row");

                //we kunnen alleen maar delen als de partner een bv heeft waar dat mee kan
                if (
                    !base.bvPartner
                        .find(":selected, :checked")
                        .is("[data-no-dental-sharing], .no-dental-sharing")
                ) {
                    if (base.checkbox.is(":checked")) {
                        $(".compare-table").addClass("delen");
                    }

                    base.compareCheckboxes.prop("checked", true);

                    if ($.trim(base.av.val()) === "") {
                        return;
                    }
                    base.avPartner.prop("disabled", true);
                    base.avPartner.val(base.av.val());
                    base.checkboxPartner.prop("checked", true);
                    base.checkboxPartner.nextAll(".note:first").slideDown(150);
                    formRowPartner.fadeIn(100);
                    // hide 'vergelijk' button for partner (NB extensive selector, because ID is not possible, code for backend same as 'verzekeringsnemer')
                    var compareTablePartner = formRowPartner
                        .closest("fieldset")
                        .prev();
                    var compareButtonPartner = compareTablePartner
                        .prev()
                        .find("li:last");
                    compareTablePartner.hide();
                    compareButtonPartner.hide();

                    // Change label text
                    var lbl = base.checkboxPartner.next("label");
                    lbl.attr("data-text-not-shared", lbl.text());
                    lbl.text(lbl.attr("data-text-shared"));

                    // trigger for template update (getting summary)
                    base.av.trigger("change.UpdateTemplate");
                }
            },

            disableSharing: function() {
                var base = this,
                    formRowPartner = base.checkboxPartner.closest(".form-row");

                base.compareCheckboxes.prop("checked", false);

                base.avPartner.prop("disabled", false);

                $(".compare-table").removeClass("delen");

                if (base.checkbox.is(":checked")) {
                    base.avPartner.trigger("change");
                }

                base.checkboxPartner.prop("checked", false);
                base.checkboxPartner.nextAll(".note:first").slideUp(100);
                formRowPartner.fadeOut(100);
                // show 'vergelijk' button for partner (NB extensive selector, because ID is not possible, code for backend same as 'verzekeringsnemer')
                var compareButtonPartner = formRowPartner
                    .closest("fieldset")
                    .prev()
                    .prev()
                    .find("li:last");
                compareButtonPartner.show();

                // Change label text
                var lbl = base.checkboxPartner.next("label"),
                    txt = lbl.attr("data-text-not-shared");
                if (txt) {
                    lbl.text(txt);
                }
            }
        };

        /** Share dentist prospect extended
         *
         * Specific functionality to choose share dentist option in prospect environment of ZZ site
         * Extended version for choosing whom to share with
         *
         */
        ZZ.ShareDentistProspectExtended = function(container) {
            var base = this;
            base.container = container;
            base.sharePersons = base.container.find("[data-share-dentist-id]");
            base.triggers = base.sharePersons.find(
                "[data-share-dentist-trigger]"
            );
            base.sharingPartnerSelections = base.triggers.nextAll("select");
            base.compareCheckboxes = base.container.find(
                ".compare-table-container :checkbox"
            );
            base.avSelects = base.container.find("[data-share-dentist-av]");
            base.sharingStatus = false; // == true if sharing is on

            $(".dental-sharing-not-possible-text").hide(0);
            $(".dental-sharing-on-text").hide(0);

            base.assignListeners();

            // sharing on init
            base.init();
        };

        ZZ.ShareDentistProspectExtended.prototype = {
            init: function() {
                var base = this,
                    curSelect;
                // sharing 'on' if checkbox is checked
                if (base.triggers.is(":checked")) {
                    base.updateSharing($(base.triggers.filter(":checked")[0]));
                }

                // disable sharing if av doesn't allow it
                base.avSelects.each(function() {
                    curSelect = $(this);
                    if (
                        curSelect
                            .find(":selected")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        var checkbox = $(
                            "[data-share-dentist-id=" +
                                curSelect.attr("data-share-dentist-av") +
                                "]"
                        ).find("[data-share-dentist-trigger]");
                        base.disableSharing(curSelect, checkbox);
                    }
                });
            },

            assignListeners: function() {
                var base = this;
                base.triggers.on(
                    "change.ShareDentistProspectExtended",
                    function() {
                        var checkbox = $(this),
                            id = checkbox
                                .parents("[data-share-dentist-id]:first")
                                .attr("data-share-dentist-id"),
                            select = $("[data-share-dentist-av=" + id + "]");

                        // if sharing is not supported with chosen option
                        if (
                            select
                                .find(":selected")
                                .is(
                                    "[data-no-dental-sharing], .no-dental-sharing"
                                )
                        ) {
                            base.disableSharing(select, checkbox);
                        } else {
                            base.enableSharing(checkbox);
                            base.updateSharing(checkbox);
                        }

                        // trigger custom event for possible additional interaction
                        checkbox.trigger("ZZ_share_dentist_change");
                    }
                );

                base.sharingPartnerSelections.on("change", function() {
                    var checkbox = $(this).prevAll(
                        "[data-share-dentist-trigger]"
                    );
                    base.updateSharing(checkbox);

                    // trigger custom event for possible additional interaction
                    var curTrigger = $(this);
                    curTrigger.trigger("ZZ_share_dentist_change");
                });

                base.avSelects.on("change", function() {
                    var select = $(this),
                        correspondingCheckbox = base.container.find(
                            "[data-share-dentist-id=" +
                                select.attr("data-share-dentist-av") +
                                "] [data-share-dentist-trigger]"
                        );

                    // remember new value
                    select.attr("data-share-dentist-av-remember", select.val());

                    // if sharing is not supported with chosen option
                    if (
                        select
                            .find(":selected")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.disableSharing(select, correspondingCheckbox);
                    }
                    // if sharing is supported, but sharing checkbox is disabled and no one is sharing
                    else if (
                        correspondingCheckbox.prop("disabled") &&
                        !base.sharingStatus
                    ) {
                        base.enableSharing(correspondingCheckbox);
                    } else if (correspondingCheckbox.is(":checked")) {
                        base.updateSharing(correspondingCheckbox);
                    }

                    // trigger custom event for possible additional interaction
                    select.trigger("ZZ_share_dentist_change");
                });

                base.compareCheckboxes.on("change", function() {
                    // toggle 'checked' status of sharing checkbox
                    var curCheck = $(this)
                        .closest(".compare-table-container")
                        .next()
                        .find("[data-share-dentist-trigger]:checkbox");
                    curCheck.prop("checked", function(i, val) {
                        return !val;
                    });
                    curCheck.trigger("change.ShareDentistProspectExtended");

                    // trigger custom event for possible additional interaction
                    var curTrigger = $(this);
                    curTrigger.trigger("ZZ_share_dentist_change");
                });
            },

            updateSharing: function(checkbox) {
                var base = this;
                base.compareCheckboxes.prop("checked", false);
                if (checkbox.is(":checked")) {
                    // sharing on
                    var id = checkbox
                            .parents("[data-share-dentist-id]:first")
                            .attr("data-share-dentist-id"),
                        sharePartnerId = checkbox.nextAll("select").val(),
                        partner = $(
                            "[data-share-dentist-id=" + sharePartnerId + "]"
                        );

                    base.share(id, sharePartnerId);
                    base.enableSharing(partner.find(":input[type=checkbox]"));
                    base.sharingStatus = true;
                    var correspondingCompareCheckboxes = checkbox
                        .closest("fieldset")
                        .prev(".compare-table-container")
                        .find(":checkbox");
                    var correspondingCompareCheckboxesPartner = partner
                        .closest("fieldset")
                        .prev(".compare-table-container")
                        .find(":checkbox");
                    correspondingCompareCheckboxes.prop("checked", true);
                    correspondingCompareCheckboxesPartner.prop("checked", true);
                } else {
                    // sharing off
                    base.sharePersons
                        .find(
                            ":input:not([data-sharing-not-possible], [type=hidden])"
                        )
                        .prop("disabled", false);
                    base.sharePersons
                        .find("input[type=checkbox]")
                        .prop("checked", false);
                    base.sharingStatus = false;
                    base.container.find(".dental-sharing-on-text").hide();

                    // reset remembered values
                    $("select[data-share-dentist-av-remember]").each(
                        function() {
                            var curSelect = $(this);
                            curSelect.val(
                                curSelect.attr("data-share-dentist-av-remember")
                            );

                            // re-init for possible consequences of switching back
                            base.init();

                            // trigger custom event for possible additional interaction
                            curSelect.trigger("ZZ_change_av");
                        }
                    );
                }
            },

            share: function(id, sharePartnerId) {
                var base = this,
                    i,
                    curPerson,
                    curInputs,
                    curId,
                    sharedAv,
                    sharingPartnerSelect;

                for (i = 0; i < base.sharePersons.length; i++) {
                    curPerson = $(base.sharePersons[i]);
                    curId = curPerson.attr("data-share-dentist-id");
                    curInputs = curPerson.find(":input").not("[type=hidden]");
                    curInputs.prop("disabled", false);
                    curPerson.find(".dental-sharing-on-text").hide();

                    // sharing partner: sharing option on
                    if (curId === sharePartnerId) {
                        curPerson
                            .find("input[type=checkbox]")
                            .prop("checked", true);
                        curPerson.find("select").val(id);

                        // remember current selected AV
                        sharedAv = base.container
                            .find("[data-share-dentist-av=" + id + "]")
                            .val();
                        sharingPartnerSelect = base.container.find(
                            "[data-share-dentist-av=" + curId + "]"
                        );
                        sharingPartnerSelect.attr(
                            "data-share-dentist-av-remember",
                            sharingPartnerSelect.val()
                        );

                        // autoselect same AV
                        sharingPartnerSelect.val(sharedAv);

                        // trigger custom event for possible additional interaction
                        sharingPartnerSelect.trigger("ZZ_change_av");

                        // show sharing specific text
                        curPerson.find(".dental-sharing-on-text").show();
                    } else if (curId === id) {
                        curPerson.find(".dental-sharing-on-text").show();
                    }
                    // disable others
                    else {
                        curInputs.prop("disabled", true);
                        curPerson
                            .find("input[type=checkbox]")
                            .prop("checked", false);

                        // reset remembered value
                        var select = base.container.find(
                            "[data-share-dentist-av=" +
                                curPerson.attr("data-share-dentist-id") +
                                "][data-share-dentist-av-remember]"
                        );
                        if (select.length > 0) {
                            select.val(
                                select.attr("data-share-dentist-av-remember")
                            );
                        }
                    }
                }
            },

            // sharing is possible in combination with selected product
            enableSharing: function(sharingCheckbox) {
                var shareWithSelect = sharingCheckbox.nextAll("select:first"),
                    sharingNotPossibleText = shareWithSelect.nextAll(
                        ".dental-sharing-not-possible-text:first"
                    );

                sharingCheckbox.removeAttr("data-sharing-not-possible");
                shareWithSelect.removeAttr("data-sharing-not-possible");
                sharingCheckbox.prop("disabled", false);
                shareWithSelect.prop("disabled", false);

                sharingNotPossibleText.hide();
            },

            // sharing is not possible in combination with selected product
            disableSharing: function(avSelect, sharingCheckbox) {
                var base = this,
                    shareWithSelect = sharingCheckbox.nextAll("select:first"),
                    sharingNotPossibleText = shareWithSelect.nextAll(
                        ".dental-sharing-not-possible-text:first"
                    );

                if (sharingCheckbox.is(":checked")) {
                    $("[data-share-dentist-trigger]").prop("checked", false);
                    base.sharingStatus = false;
                    base.updateSharing(sharingCheckbox);
                }
                sharingCheckbox.attr("data-sharing-not-possible", true);
                shareWithSelect.attr("data-sharing-not-possible", true);
                sharingCheckbox.prop("disabled", true);
                shareWithSelect.prop("disabled", true);

                // set remembered value
                shareWithSelect.val(
                    shareWithSelect.attr("data-share-dentist-av-remember")
                );

                var selectedAvText = avSelect.find(":selected").text();
                sharingNotPossibleText.find(".insurance").text(selectedAvText);
                sharingNotPossibleText.show(150);
            }
        };
    })(jQuery);
}
